import { render, staticRenderFns } from "./dashboard-component.vue?vue&type=template&id=f9ae60da&scoped=true&"
import script from "./dashboard-component.vue?vue&type=script&lang=ts&"
export * from "./dashboard-component.vue?vue&type=script&lang=ts&"
import style0 from "./dashboard-component.vue?vue&type=style&index=0&id=f9ae60da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9ae60da",
  null
  
)

export default component.exports